export { MedicalCardRegistry } from './MedicalCardRegistry.main';
export { useMedicalCardRegistryEffects } from '../hooks/useMedicalCardRegistryEffects';
